import React, { useEffect, useState } from "react";
import { MdClose, MdAdd } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import AppLayout from "../components/AppLayout";
import Header from "../components/header";
import { useTenant } from "../context/TenantContext";
import { useLabels } from "../utils/labels";
import StaffTable, { StaffTableMobile } from "../components/staffTable";
import {
  addBusinessStaff,
  addStaffDashboard,
  deleteBusinessStaff,
  editBusinessStaff,
  getBusinessServices,
  getBusinessStaff,
} from "../logic/business/action";
import { Multiselect } from "multiselect-react-dropdown";
import { addMinutes, getTimings } from "../utils/static_data";
import moment from "moment";
import {
  addTimeSlot,
  addTimeSlotBulk,
  removeTimeSlot,
  removeTimeSlotBulk
} from "../logic/timings/reducer";
import { toast } from "react-toastify";
import {
  addStaffTimingsForStaff,
  getStaffTimingsByStaff,
} from "../logic/timings/action";
import { Button, IconButton, Box, Typography } from "@mui/material";
import * as Yup from 'yup';
import FormikForm from "../components/commonForm";
import MoreFields from "../components/MoreFields";
import { feildsAddStaff, initialValuesAddStaff, validationSchemaAddStaff } from "../fromsUtil/addStaff";
import InputComponents from "../components/input";
import { getData } from "../utils/serverHelper";
import { BUSINESS_PRESET } from "../utils/urls";

const StaffScreen = () => {
  const dispatch = useDispatch();
  const { tenant } = useTenant();
  const labels = useLabels();
  const [state, setState] = useState(15);
  const [timingsD, setTimingsD] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setendTime] = useState("");
  const [slotOpen, setSlotOpn] = useState(false);
  const [slots, setSlots] = useState({
    recurring: "no_recursion",
    staff: 0,
    date: new Date(),
    dateS: `${new Date().getFullYear()}-${
      new Date().getMonth() + 1 > 9
        ? new Date().getMonth() + 1
        : `0${new Date().getMonth() + 1}`
    }-${new Date().getDate()}`,
  });
  const [stateForm, setStateForm] = useState({
    name: "",
    contact: "",
    email: "",
    role: "",
    services: "",
    password: "",
    staff_color: 0,
  });
  const [editMode, setEditMode] = useState(false);
  const [addStaffMode,setAddStaffMode] = useState(false)

  const [editId, setEditId] = useState(0);
  const selectorBizz = useSelector((state) => state.business);
  const selector = useSelector((state) => state.auth);


  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [staffToDelete, setStaffToDelete] = useState(null);

  
  const selectorTimings = useSelector((state) => state.timings);
  
  useEffect(() => {
    if (selector?.user?.business_id) {
      getBusinessStaff(dispatch, selector?.user?.business_id);
      getBusinessServices(dispatch, selector?.user?.business_id);
    }
  }, [selector?.user?.business_id]);

  useEffect(() => {
    setTimingsD(getTimings("09:00:00", "18:00:00", 15));
  }, []);

  console.log(slots.dateS, "date S");

  useEffect(() => {
    if (slots.staff !== 0 && slots.date) {
      getStaffTimingsByStaff(
        dispatch,
        slots.staff,
        selector?.user?.business_id,
        slots.date.toISOString()
      );
    }
  }, [slots]);


  const handleDeleteCustomer=(staff_id)=>{
    // console.log(staff_id)
    deleteBusinessStaff(dispatch,staff_id)
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }
  const onSubmiteditStaff = async (id,data) => {
    try {
      editBusinessStaff(dispatch,id,data);
      setTimeout(() => {
        getBusinessStaff(dispatch, selector?.user?.business_id);
      }, 300);
      setAddStaffMode(false);
    } catch (error) {
      console.log(error);
    }
  };
  const addStaff = async () => {
    if (editId === 0) {
      setStateForm((prev) => ({
        ...prev,
        staff_color: Math.floor(Math.random() * (6 - 1 + 1) + 1),
      }));
      await addBusinessStaff(dispatch, selector?.user?.business_id, stateForm);
      setEditMode(false);
    } else {
      await editBusinessStaff(
        dispatch,
        selector?.user?.business_id,
        stateForm,
        editId
      );
      setEditMode(false);
    }
  };

  console.log(timingsD);
  return (
    <AppLayout>
      <div
        className={`fixed top-0 left-0 w-screen h-screen bg-black/40 ${
          slotOpen ? "flex" : "hidden"
        } items-center justify-center`}
      >
        <div className="w-[80%] h-[80%] lg:w-1/2 lg:h-1/2 overflow-y-scroll bg-white rounded-md p-4 flex flex-col gap-4 items-center relative">
          <MdClose
            className="absolute top-4 right-4 cursor-pointer"
            onClick={() => setSlotOpn(false)}
          />
          <h4>Provide slots</h4>
          <div className="flex justify-around w-full items-start">
            <div className="w-[40%]">
              <label htmlFor="staff_select">Select Staff</label>
              <select
                name="staff_select"
                id="staff_select"
                value={slots.staff}
                onChange={(ev) =>
                  setSlots((prev) => ({
                    ...prev,
                    staff: parseInt(ev.target.value),
                  }))
                }
              >
                <option value={0}>All staff</option>
                {selectorBizz?.staff?.map((e, i) => (
                  <option value={e.staff_id}>{e?.name}</option>
                ))}
              </select>

              <label htmlFor="duration_select">Select Duration</label>
              <select
                name="duration_select"
                id="duration_select"
                onChange={(e) => {
                  dispatch(removeTimeSlotBulk());
                  setState(parseInt(e.target.value));
                  setTimingsD(getTimings('09:00:00','18:00:00',parseInt(e.target.value)));
                }}
              >
                <option value={15}>15 Min</option>
                <option value={30}>30 Min</option>
                <option value={45}>45 Min</option>
                <option value={60}>60 Min</option>
              </select>
            </div>
            <div className="w-[40%]">
              <label htmlFor="staff_recursion">Recurring</label>
              <select
                name="slect_recursion"
                id="selcet recursion"
                value={slots.recurring}
                onChange={(ev) => {
                  // getStaffTimings(dispatch,)

                  setSlots((prev) => ({ ...prev, recurring: ev.target.value }));
                }}
              >
                <option value="no_recursion">No Recurring</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </select>
              {slots.recurring !== "daily" ? (
                <>
                  <label htmlFor="date_select">Select Date</label>
                  <input
                    type="date"
                    id="date_select"
                    name="date_select"
                    defaultValue={new Date().toLocaleDateString("en-IN")}
                    value={slots.dateS}
                    onChange={(ev) => {
                      // console.log(ev.target.value);
                      setSlots((prev) => ({
                        ...prev,
                        date: ev.target.valueAsDate,
                        dateS: ev.target.value,
                      }));
                    }}
                  />
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="flex gap-4">
            <button onClick={()=>{
              timingsD.forEach(e=>{
                dispatch(addTimeSlotBulk(e));
              });
            }}>Select All Slots</button>
            <button
            onClick={()=>{
              timingsD.forEach((e)=>{
                dispatch(removeTimeSlot(e));
              });
            }}
            className="bg-red-800">Deselect All Slots</button>
          </div>

          <div className="flex flex-wrap items-end w-full gap-4">
            <div className="flex-1 min-w-full lg:min-w-[22%]">
              <label htmlFor="start_time">Start Time</label>
              <input
                type="time"
                name="start_time"
                id="start_time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              />
            </div>
            <div  className="flex-1 min-w-full lg:min-w-[22%]">
              <label htmlFor="end_time">End Time</label>
              <input
                type="time"
                name="end_time"
                id="end_time"
                value={endTime}
                onChange={(e) => setendTime(e.target.value)}
              />
            </div>
            <button
              onClick={() => {
                let start = startTime;
                let end = endTime;
                let minute = start.split(":")[1];
                let minuteEnd = end.split(":")[1];

                let hourEnd = end.split(":")[0];
                let hourStart = start.split(":")[0];
                if (parseInt(hourStart) > parseInt(hourEnd)) {
                  toast.error("Please use starttime before endtime");
                  return;
                }
                if (parseInt(hourStart) < 9) {
                  toast.error("Please use starttime after 9 AM");
                  return;
                } else if (parseInt(hourEnd) > 18) {
                  toast.error("Please use endtime before 6 PM");
                  return;
                }
                if (parseInt(minute) > 37) {
                  start = start.replace(minute, "45");
                } else if (parseInt(minute) > 22) {
                  start = start.replace(minute, "30");
                } else if (parseInt(minute) > 7) {
                  start = start.replace(minute, "15");
                } else {
                  start = start.replace(minute, "00");
                }

                if (parseInt(minuteEnd) > 37) {
                  end = end.replace(minuteEnd, "45");
                } else if (parseInt(minuteEnd) > 22) {
                  end = end.replace(minuteEnd, "30");
                } else if (parseInt(minuteEnd) > 7) {
                  end = end.replace(minuteEnd, "15");
                } else {
                  end = end.replace(minuteEnd, "00");
                }
                console.log(start);
                console.log(end);
                start += ":00";
                end += ":00";
                dispatch(addTimeSlotBulk(start));
                while (start !== end) {
                  start = addMinutes(start, 15);
                  console.log(start);
                  dispatch(addTimeSlotBulk(start));
                }
              }}
            >
              Available
            </button>
            <button
              className="bg-red-800"
              onClick={() => {
                let start = startTime;
                let end = endTime;
                let minute = start.split(":")[1];
                let minuteEnd = end.split(":")[1];
                let hourEnd = end.split(":")[0];
                let hourStart = start.split(":")[0];
                if (parseInt(hourStart) > parseInt(hourEnd)) {
                  toast.error("Please use starttime before endtime");
                  return;
                }
                if (parseInt(hourStart) < 9) {
                  toast.error("Please use starttime after 9 AM");
                  return;
                } else if (parseInt(hourEnd) > 18) {
                  toast.error("Please use endtime before 6 PM");
                  return;
                }
                if (parseInt(minute) > 37) {
                  start = start.replace(minute, "45");
                } else if (parseInt(minute) > 22) {
                  start = start.replace(minute, "30");
                } else if (parseInt(minute) > 7) {
                  start = start.replace(minute, "15");
                } else {
                  start = start.replace(minute, "00");
                }

                if (parseInt(minuteEnd) > 37) {
                  end = end.replace(minuteEnd, "45");
                } else if (parseInt(minuteEnd) > 22) {
                  end = end.replace(minuteEnd, "30");
                } else if (parseInt(minuteEnd) > 7) {
                  end = end.replace(minuteEnd, "15");
                } else {
                  end = end.replace(minuteEnd, "00");
                }
                console.log(start);
                console.log(end);
                start += ":00";
                end += ":00";
                dispatch(removeTimeSlot(start));
                while (start !== end) {
                  start = addMinutes(start, 15);
                  // console.log(start);
                  dispatch(removeTimeSlot(start));
                }
              }}
            >
              Unavailable
            </button>
          </div>
          <div className="w-full items-center gap-4 flex flex-wrap">
            {getTimings("09:00:00", "18:00:00", state).map((e, i) =>
              e !== "18:00:00" ? (
                <p
                  onClick={() => dispatch(addTimeSlot(e))}
                  className={`cursor-pointer flex items-center gap-2 ${
                    selectorTimings?.timings.includes(e)
                      ? "bg-green-100"
                      : "bg-blue-100"
                  } rounded-md p-2`}
                >
                  <span>
                    {moment(e, "HH:mm:ss").format("hh:mm A")} -{" "}
                    {moment(addMinutes(e, state), "HH:mm:ss").format("hh:mm A")}
                  </span>
                </p>
              ) : (
                ""
              )
            )}
          </div>
          <button
            className="disabled:bg-gray-600"
            disabled={selectorTimings?.addTimingsRequest}
            onClick={() => {
              addStaffTimingsForStaff(
                dispatch,
                slots.staff,
                selector?.user?.business_id,
                `${slots.date.getFullYear()}-${
                  slots.date.getMonth() + 1
                }-${slots.date.getDate()}`,
                selectorTimings?.timings.map(e=>({start_time:e,end_time:addMinutes(e,state)})),
                slots.recurring
              );
            }}
          >
            Proceed
          </button>
        </div>
      </div>

      {/* <div
        className={`h-screen w-screen bg-black/60 absolute z-50 ${
          editMode ? "flex items-center justify-center" : "hidden"
        } `}
      >
        <div className="bg-white w-[80%] h-[80%] lg:w-1/2 lg:h-1/2 overflow-y-scroll p-8 relative flex flex-col gap-2">
          <span
            className="absolute top-2 right-2 cursor-pointer"
            onClick={() => setEditMode((prev) => !prev)}
          >
            <RxCross2 size={24} />
          </span>
          <h4 className="font-bold text-xl text-blue-800 text-center ">
            {editId === 0 ? "Add Staff" : "Edit Staff Details"}
          </h4>

          <div>
            <label htmlFor="name">Name</label>

            <input
              type="text"
              name="name"
              value={stateForm.name}
              onChange={(e) =>
                setStateForm((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          <div>
            <label htmlFor="contact">Mobile Number</label>
            <input
              type="text"
              name="contact"
              value={stateForm.contact}
              onChange={(e) =>
                setStateForm((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          <div>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              name="email"
              value={stateForm.email}
              onChange={(e) =>
                setStateForm((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            />
          </div>
          {editId === 0 ? (
            <div>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                value={stateForm.password}
                onChange={(e) =>
                  setStateForm((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              />
            </div>
          ) : (
            ""
          )}

          <div>
            <label htmlFor="role">Role</label>
            <select
              name="role"
              id="role"
              value={stateForm.role}
              onChange={(e) =>
                setStateForm((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
            >
              <option value="">Select Role</option>
              <option value="Admin">Admin</option>
              <option value="Doctor">Doctor</option>
            </select>
          </div>
          <div className="w-full">
            <label htmlFor="role">Services</label>

            <Multiselect
              options={selectorBizz?.services}
              displayValue="service"
              selectedValues={selectorBizz?.services?.filter((ele) =>
                stateForm.services
                  .split(",")
                  .includes(ele.service_id.toString())
              )}
              onSelect={(list, item) => {
                console.log(list?.map((e) => e.service_id).join(","));
                setStateForm((prev) => ({
                  ...prev,
                  services: list?.map((e) => e.service_id).join(","),
                }));
              }}
            />
          </div>
          <button onClick={addStaff}>Save Changes</button>
        </div>
      </div>
       */}
        {
          editMode?
          <StaffPopup closePopup={()=>setEditMode(false)}/>
          :<></>
        }
        {addStaffMode ? (
          <EditStaffPopup 
            closePopup={() => setAddStaffMode(false)}
            staffData={stateForm}
            editId={editId}
            onSubmit={onSubmiteditStaff}
            staffAlias={labels.staff_plural || "Staff"}
          />
        ) : null}
    {showConfirmationPopup && (
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', md: '400px' },
          zIndex: 1300,
          backgroundColor: '#ffffff',
          borderRadius: 2,
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          p: 3
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, textAlign: 'center', mb: 3, color: '#1f2937' }}>
          Are you sure you want to delete this {labels.staff?.toLowerCase() || "staff"}?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="outlined"
            onClick={() => setShowConfirmationPopup(false)}
            sx={{
              textTransform: 'none',
              px: 3,
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: '#f9fafb'
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleDeleteCustomer(staffToDelete);
              setShowConfirmationPopup(false);
            }}
            sx={{
              textTransform: 'none',
              px: 3,
              backgroundColor: '#ef4444',
              '&:hover': {
                backgroundColor: '#dc2626'
              }
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    )}
      <Box sx={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column', 
        overflow: 'hidden',
        px: 3,
        pt: 1,
        pb: 3, 
        gap: 1 
      }}>
        <Header
          title={labels.staff_plural || "Staff"}
          actions={
            <Button
              variant="contained"
              startIcon={<MdAdd />}
              onClick={() => {
                setStateForm({
                  name: "",
                  contact: "",
                  email: "",
                  role: "",
                  services: "",
                  password: "",
                  staff_color: 0,
                });
                setEditId(0);
                setEditMode((prev) => !prev);
              }}
              sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '12px',
                px: 3,
                py: 1,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
                  boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
                },
              }}
            >
              Add {labels.staff || "Staff"}
            </Button>
          }
        />
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ width: '100%', flex: 1, display: { xs: 'none', lg: 'flex' }, flexDirection: 'column', minHeight: 0 }}>
            <StaffTable
              setEditMode={(data) => {
                setStateForm({ ...data });
                setEditId(data?.staff_id);
                setEditMode((prev) => !prev);
              }}
              setAddStaffMode={(data) => {
                setEditId(data?.staff_id);
                setAddStaffMode((prev) => !prev)
                setStateForm({ ...data});
              }}
              onDeleteStaff={(data) => {
                setStaffToDelete(data);
                setShowConfirmationPopup(true); 
              }}
              staffAlias={labels.staff_plural || "Staff"}
            />
          </Box>
          <Box sx={{ width: '100%', flex: 1, display: { xs: 'flex', lg: 'none' }, flexDirection: 'column', minHeight: 0 }}>
            <StaffTableMobile
              setEditMode={(data) => {
                setStateForm({ ...data });
                setEditId(data?.staff_id);
                setEditMode((prev) => !prev);
              }}
              setAddStaffMode={(data) => {
                setEditId(data?.staff_id);
                setAddStaffMode((prev) => !prev)
                setStateForm({ ...data});
              }}
              onDeleteStaff={(data) => {
                setStaffToDelete(data);
                setShowConfirmationPopup(true); 
              }}
              staffAlias={labels.staff_plural || "Staff"}
            />
          </Box>
        </Box>
      </Box>
    </AppLayout>
  );
};


const StaffPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector(state=>state.business);
  const [customFields, setCustomFields] = useState({});
  const [selectedServices, setselectedServices] = useState([]);
  const [openservice, setopenservice] = useState(false);
  useEffect(() => {
    getBusinessServices(dispatch,selector.details?.business_id);
  
  }, [])
  
  const submitService = async (values) => {
    await addStaffDashboard(dispatch, {...values,services:selectedServices.join(','), custom_fields: customFields});  
    closePopup();
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const openServiceDrop = ()=>{
    setopenservice(prev=>!prev);
  }
  return (
    <div className="w-screen z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center">
     {
      !openservice?<></>:
       <div className={`absolute z-30 w-full h-full bg-black/40 top-0 left-0 flex items-center justify-center`}>
      <div className="w-[50%] lg:w-[30%] p-4 lg:p-10 bg-white rounded-lg relative">
      <h4>Select Services</h4>
      <div className="flex flex-col gap-2 w-full py-4">
      <div  className="w-full flex items-center justify-between">
            <p>All</p>
            <input checked={selectedServices.length === selector.services?.length} onChange={(ev)=>{
              if(Array.isArray(selector.services)){
              if(selectedServices.length === selector.services?.length){
                setselectedServices([]);
              }else{
                setselectedServices(selector.services?.map((e)=>e.service_id));
              }
            }else{
                setselectedServices([]);
              }
            }} className="!flex-none !w-fit" type="checkbox"/>
      </div>
      {
        selector.services?.map((e,i)=><div key={i} className="w-full flex items-center justify-between">
            <p>{e.service}</p>
            <input checked={selectedServices.includes(e.service_id)} onChange={(ev)=>{
              if(selectedServices.includes(e.service_id)){
                setselectedServices(prev=>prev.filter(el=>el !== e.service_id))
              }else{
                setselectedServices(prev=>[...prev,e.service_id])
              }
            }} className="!flex-none !w-fit" type="checkbox"/>
        </div>)
      }
      </div>
      <button onClick={openServiceDrop} className="!w-full">Select</button>
      </div>
      </div>
    }
      <div className="w-[90%] lg:w-[50%] min-h-[50%] p-10 bg-white rounded-lg relative">
      
        <span
          onClick={closePopup}
          className="cursor-pointer absolute top-4 right-4"
        >
          <MdClose />
        </span>
        <div className="flex flex-col gap-4 items-center">
        <h4 className="font-bold text-xl text-blue-800 text-center ">
              {/* {state === 0 && "Edit Service"}
        {state === 1 && "Edit Staff Details"} */}
              {"Add Staff Details"}
              {/* {state === 3 && "Edit Appointment"}
        {state === 4 && "Edit Document"}
        {state === 5 && "Edit Field"} */}
            </h4>
          <FormikForm
                initialValues={initialValuesAddStaff}
                fields={feildsAddStaff(
                  [
                    {
                      value: 'admin',
                      label: 'Admin',
                      disabled: false,
                    },
                    {
                      value: 'staff',
                      label: 'Staff',
                      disabled: false,
                    },
                  ]
                )}
                validationSchema={validationSchemaAddStaff}
                extra_element={
                  <>
                  <div onClick={openServiceDrop}>
                  <InputComponents disabled={true} placeholder={`Selected services (${selectedServices.length}/${selector.services?.length})`}/>
                  </div>
                  <MoreFields module="staff" values={customFields} onChange={setCustomFields} />
                  </>
                }
                action={(disabled) => (
                  <button disabled={disabled} className="button w-full" type="submit">
                    Proceed
                  </button>
                )}
                onSubmit={submitService}
              />
        </div>
      </div>
    </div>
  );
};

const EditStaffPopup = ({ closePopup, staffData, editId, onSubmit, staffAlias = 'Staff' }) => {
  const dispatch = useDispatch();
  const { tenant } = useTenant();
  const labels = useLabels();
  const selector = useSelector(state=>state.business);
  const selectorAuth = useSelector(state => state.auth);
  const [selectedServices, setselectedServices] = useState([]);
  const [openservice, setopenservice] = useState(false);
  const [customFields, setCustomFields] = useState({});
  
  useEffect(() => {
    getBusinessServices(dispatch, selectorAuth?.user?.business_id);
  }, []);

  useEffect(() => {
    // Parse services string to array
    if (staffData?.services) {
      const serviceIds = staffData.services.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
      const services = selector?.services?.filter(s => serviceIds.includes(s.service_id)) || [];
      setselectedServices(services);
    } else {
      setselectedServices([]);
    }
  }, [staffData, selector?.services]);
  
  const submitService = async (values) => {
    await onSubmit(editId, {...values, services: selectedServices.map(s => s.service_id).join(','), custom_fields: customFields});
    closePopup();
  };

  const openServiceDrop = () => {
    setopenservice(prev => !prev);
  };

  // Create initial values for edit form (without password requirement)
  const initialValuesEditStaff = {
    name: staffData?.name || "",
    contact: staffData?.contact || "",
    role: staffData?.role || "",
    services: staffData?.services || "",
    staff_color: staffData?.staff_color || 0,
    email: staffData?.email || "",
    password: "", // Empty for edit
  };

  // Validation schema without password requirement for edit
  const validationSchemaEditStaff = Yup.object().shape({
    name: Yup.string().required('Cannot be empty'),
    role: Yup.string().required('Cannot be empty'),
    contact: Yup.string().required('Cannot be empty').matches(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/, 'Please enter valid phone number'),
    email: Yup.string().required('Cannot be empty').email('Invalid email'),
    password: Yup.string().min(6, 'Password should be atleast 6 character long'), // Optional for edit
  });

  return (
    <div className="w-screen z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center">
      {!openservice ? null : (
        <div className={`absolute z-30 w-full h-full bg-black/40 top-0 left-0 flex items-center justify-center`}>
          <div className="w-[50%] lg:w-[30%] p-4 lg:p-10 bg-white rounded-lg relative">
            <h4>Select Services</h4>
            <div className="flex flex-col gap-2 w-full py-4">
              <div className="w-full flex items-center justify-between">
                <p>All</p>
                <input 
                  checked={selectedServices.length === selector.services?.length && selector.services?.length > 0} 
                  onChange={(ev) => {
                    if(Array.isArray(selector.services)){
                      if(selectedServices.length === selector.services?.length){
                        setselectedServices([]);
                      } else {
                        setselectedServices(selector.services || []);
                      }
                    } else {
                      setselectedServices([]);
                    }
                  }} 
                  className="!flex-none !w-fit" 
                  type="checkbox"
                />
              </div>
              {selector.services?.map((e, i) => (
                <div key={i} className="w-full flex items-center justify-between">
                  <p>{e.service}</p>
                  <input 
                    checked={selectedServices.some(s => s.service_id === e.service_id)} 
                    onChange={(ev) => {
                      if(selectedServices.some(s => s.service_id === e.service_id)){
                        setselectedServices(prev => prev.filter(el => el.service_id !== e.service_id));
                      } else {
                        setselectedServices(prev => [...prev, e]);
                      }
                    }} 
                    className="!flex-none !w-fit" 
                    type="checkbox"
                  />
                </div>
              ))}
            </div>
            <button onClick={openServiceDrop} className="!w-full">Select</button>
          </div>
        </div>
      )}
      <div className="w-[90%] lg:w-[50%] min-h-[50%] p-10 bg-white rounded-lg relative">
        <span
          onClick={closePopup}
          className="cursor-pointer absolute top-4 right-4"
        >
          <MdClose />
        </span>
        <div className="flex flex-col gap-4 items-center">
          <h4 className="font-bold text-xl text-blue-800 text-center ">
            Edit {labels.staff || staffAlias} Details
          </h4>
          <FormikForm
            initialValues={initialValuesEditStaff}
            fields={feildsAddStaff(
              [
                {
                  value: 'admin',
                  label: 'Admin',
                  disabled: false,
                },
                {
                  value: 'staff',
                  label: 'Staff',
                  disabled: false,
                },
              ]
            )}
            validationSchema={validationSchemaEditStaff}
            extra_element={
              <>
              <div onClick={openServiceDrop}>
                <InputComponents 
                  disabled={true} 
                  placeholder={`Selected services (${selectedServices.length}/${selector.services?.length || 0})`}
                />
              </div>
              <MoreFields module="staff" recordId={editId} values={customFields} onChange={setCustomFields} />
              </>
            }
            action={(disabled) => (
              <button disabled={disabled} className="button w-full" type="submit">
                Save Changes
              </button>
            )}
            onSubmit={submitService}
          />
        </div>
      </div>
    </div>
  );
};

export default StaffScreen;
